import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'macplanning-table-size-menu-tab',
    templateUrl: './size.menu.tab.html'
})
export class MacPlanningSizeMenuTab {

    //#region SelectedItem
    SelectedItemValue;

    @Input()
    get SelectedItem() {
        return this.SelectedItemValue;
    }
    set SelectedItem(val) {
        this.SelectedItemValue = val;
        if (this.SelectedItemValue && this.SelectedItemValue.TableSize == null) {
            this.SelectedItemValue.TableSize = {
                Columns: 26,
                Rows: 100
            };
        }
        this.SelectedItemChange.emit(this.SelectedItemValue);
    }

    @Output() SelectedItemChange = new EventEmitter<any>();
    //#endregion

    SettingsChanged() {
        this.SelectedItem.ValuesChanged.next();
    }
}
